import React from 'react';
import Icon from 'assets/icons';
import classnames from 'classnames';
import styles from './SecureText.module.scss';

interface SecureTextProps {
  className: string;
}

export const SecureText: React.FC<SecureTextProps> = ({ className }) => {
  return (
    <div className={classnames(className, styles.secureText)}>
      {
        // until asset/Icons has been made type safe
        // @ts-ignore
        <Icon.LockClosed className={styles.icon} />
      }
      Secure Connection
    </div>
  );
};
